// extracted by mini-css-extract-plugin
export var active = "_2a-9";
export var backButton = "_2a-8";
export var clone = "_2a-e";
export var collapseBar = "_2a-k";
export var collapseMode = "_2a-m";
export var collapsed = "_2a-o";
export var dimmed = "_2a-i";
export var dragHandle = "_2a-c";
export var dropdownIcon = "_2a-g";
export var expanding = "_2a-n";
export var hidden = "_2a-x";
export var iconContainer = "_2a-q";
export var iconSwapper = "_2a-w";
export var navItem = "_2a-6";
export var navItemIcon = "_2a-f";
export var navProfile = "_2a-7";
export var notificationCountBadge = "_2a-j";
export var notificationDot = "_2a-r";
export var optionsContainer = "_2a-h";
export var primaryNav = "_2a-0";
export var primaryNavDivider = "_2a-v";
export var primaryNavResizeHandle = "_2a-2";
export var primaryNavResizing = "_2a-1";
export var primaryNavTabSection = "_2a-u";
export var primaryTab = "_2a-p";
export var primaryTabIconBox = "_2a-s";
export var secondaryNav = "_2a-3";
export var selected = "_2a-t";
export var settingsNav = "_2a-4";
export var settingsNavItems = "_2a-5";
export var show = "_2a-d";
export var sideNav = "_2a-l";
export var teamItem = "_2a-a";
export var userProfileItem = "_2a-b";